import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { Popover } from './Popover';
import s from './Popover.module.css';

/** The ⓘ behind which a panel explains itself — units, method, and stated limitations. */
export function InfoHint({ children, label = 'About this', size = 18 }: { children: ReactNode; label?: string; size?: number }) {
  return (
    <Popover
      width={320}
      trigger={(p) => (
        <button type="button" className={s.hintTrigger} aria-label={label} {...p}>
          <Icon name="info" size={size} />
        </button>
      )}
    >
      <div className={s.hint}>{children}</div>
    </Popover>
  );
}
